<app-edit-header
	class="modal-header"
	cancelTooltip="Close"
	[buttonTemplateRef]=""
	[cancelFn]="close"
	[cancelAccessKey]="'w'"
	[title]="'History'"
	[headerClass]="'w-100 bg-transparent text-primary'"
	[rowClass]="'row'"
></app-edit-header>
<div
	class="progress-bar progress-bar progress-bar-striped progress-bar bg-secondary"
	role="progressbar"
	style="min-height: 5px; z-index: 0"
	[ngStyle]="{ width: '100%' }"
></div>
<div class="bg-light border-bottom container-scroll">
	<ul
		ngbNav
		#nav="ngbNav"
		(navChange)="onNavChange($event)"
		[(activeId)]="active"
		class="nav-tabs justify-content-center"
	>
		<li [ngbNavItem]="1" class="bg-light">
			<button ngbNavLink>Modification Log</button>
			<ng-template ngbNavContent>
				<div class="modal-body history-tab-body">
					<ng-container *ngIf="listingHistoryLoading$ | async">
						<div class="spinner-overlay" data-cy="history-loading-overlay">
							<div class="d-flex justify-content-center">
								<div
									class="spinner-border text-primary"
									role="status"
									style="width: 3rem; height: 3rem; z-index: 20"
								>
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container
						*ngIf="listingHistoryGroup$ | async as listingHistoryGroups; else noHistory"
					>
						<div *ngFor="let listingHistories of listingHistoryGroups" class="col">
							<app-history-row
								[listingHistories]="listingHistories"
								[showDifference]="defaultDifferencesToggle$ | async"
							></app-history-row>
						</div>
					</ng-container>
				</div>
			</ng-template>
		</li>
		<li [ngbNavItem]="2" class="bg-light">
			<button ngbNavLink nstarButton>
				Listing History
				<i
					nstarIcon
					placement="right"
					ngbTooltip="History that is shared with Matrix, Flexmls, etc."
					>help</i
				>
			</button>
			<ng-template ngbNavContent>
				<div class="modal-body history-tab-body">
					<ng-container *ngIf="listingAuditLoading$ | async">
						<div class="spinner-overlay" data-cy="audit-loading-overlay">
							<div class="d-flex justify-content-center">
								<div
									class="spinner-border text-primary"
									role="status"
									style="width: 3rem; height: 3rem; z-index: 20"
								>
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						</div>
					</ng-container>
					<ng-container *ngIf="listingAudit$ | async as listingAuditGroups">
						<ng-container *ngIf="listingAuditGroups.length > 0; else noHistory">
							<div *ngFor="let listingAudit of listingAuditGroups; let last = last" class="col">
								<app-history-row
									[listingHistories]="listingAudit"
									[showDifference]="defaultDifferencesToggle$ | async"
									[modifyListingAudit]="!last && hasListingAuditPermissions$ | async"
									(handleDeleteEvent)="deleteListingAudit($event)"
								></app-history-row>
							</div>
						</ng-container>
					</ng-container>
				</div>
			</ng-template>
		</li>
	</ul>
	<div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>

<ng-template #noHistory>
	<div class="col no-history">There is no {{ activeTab }} data to display.</div>
</ng-template>
